"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFetchPrescribers = useFetchPrescribers;
var _react = require("react");
var _ = require("./");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function composeCliniciansErxIdsUrl(_ref) {
  var url = _ref.url,
    erxIds = _ref.erxIds;
  var uniqueIds = _toConsumableArray(new Set(erxIds));
  var params = uniqueIds.map(function (id) {
    return "ids[]=".concat(id);
  }).join('&');
  return [url, params].filter(function (d) {
    return !!d;
  }).join('?');
}
function useFetchPrescribers(_ref2) {
  var medications = _ref2.medications;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  var _useFetch = (0, _.useFetch)(url, [], !!(url && medications !== null && medications !== void 0 && medications.length)),
    data = _useFetch.data;
  (0, _react.useEffect)(function () {
    var erxIds = (medications || []).map(function (m) {
      return m.prescriberId;
    });
    if (erxIds.length) {
      var _url = composeCliniciansErxIdsUrl({
        url: (0, _.getClinicianListByErxIdUrl)(),
        erxIds: erxIds
      });
      setUrl(_url);
    }
  }, [medications]);
  return {
    prescribers: !(data !== null && data !== void 0 && data.error) && data || []
  };
}